export const filterColors = {
  Color1: { value: '#437e99', name: 'Blå' }, // blue
  Color2: { value: '#595448', name: 'Brun' }, // brown
  Color3: { value: ['#ffffff', '#e8e8e8'], name: 'Transparant' }, // transparent
  Color4: { value: '#959590', name: 'Grå' }, // grey
  Color5: { value: '#536c4b', name: 'Grön' }, // green
  Color6: { value: '#e9ce4e', name: 'Gul' }, // yellow
  Color7: { value: ['#b87333', '#ffaf65', '#b87333'], name: 'Koppar' }, // copper
  Color8: { value: ['#3e4147', '#ffffff', '#3e4147'], name: 'Metall' }, // metal
  Color9: { value: '#614672', name: 'Lila' }, // purple
  Color10: { value: ['#32996f', '#8bbe57', '#db6312', '#407aaa'], name: 'Flerfärgad' }, // multi
  Color11: { value: ['#b5a642', '#ffeb67', '#b5a642'], name: 'Mässing' }, // brass
  Color12: { value: '#ca8400', name: 'Orange' }, // orange
  Color13: { value: '#cdadc2', name: 'Rosa' }, // pink
  Color14: { value: '#912113', name: 'Röd' }, // red
  Color15: { value: '#2f2f2D', name: 'Svart' }, // black
  Color16: { value: '#ffffff', name: 'Vit' }, // white
  Color18: { value: '#dbcbaa', name: 'Beige' },
  Color19: { value: '#7c5024', name: 'Trä' }
};



// WEBPACK FOOTER //
// ./src/constants/filterColors.js